import { render, staticRenderFns } from "./Kpost.vue?vue&type=template&id=84020500"
import script from "./Kpost.vue?vue&type=script&lang=js"
export * from "./Kpost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports